<div class="w-full py-3 px-2 lg:px-4">

  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
      <svg class="size-6 cursor-pointer" [routerLink]="['/rate-list-generator']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">

        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>

      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        {{ assetForm.get('id')?.value ? 'Edit Asset' : 'Add New Asset' }}
      </span>
    </div>
  </div>


  <form [formGroup]="assetForm" (ngSubmit)="onSubmit()">
    <div class="w-full mt-3 mb-4 lg:mb-0">
      <div
        class="w-full bg-[#FFF5F2] p-3 rounded-md grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8 gap-2 space-y-0.5">

        <div class="col-span-1">
          <div class="relative max-w-sm"><input id="date" type="date" formControlName="date"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " /><label for="date"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Date</label>
          </div>
        </div>
        <div class="col-span-1">
          <div class="relative"><input type="text" id="asset_name" formControlName="asset_name"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " autocomplete="off" /><label for="asset_name"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Asset
              Name*</label>
          </div>
            <div *ngIf="assetForm.get('asset_name')?.invalid && assetForm.get('asset_name')?.touched"
              class="text-red-500 text-xs mt-1">Asset name is required.</div>
        </div>
        <div class="col-span-1">
          <div class="relative"><input type="number" id="value" formControlName="value"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " autocomplete="off" /><label for="value"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Value*</label>
          </div>
          <div *ngIf="assetForm.get('value')?.invalid && assetForm.get('value')?.touched"
              class="text-red-500 text-xs mt-1">Value is required.</div>
        </div>
        <div class="col-span-1">
          <div class="relative max-w-sm"><input id="purchase_date" type="date" formControlName="purchase_date"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder="" /><label for="purchase_date"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Purchase
              Date*</label>
          </div>
            <div *ngIf="assetForm.get('purchase_date')?.invalid && assetForm.get('purchase_date')?.touched"
              class="text-red-500 text-xs mt-1">Purchase date is required.</div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="flex items-center justify-end gap-3">

            <button *ngIf="!assetForm.get('id')?.value" type="submit" [disabled]="assetForm.invalid || isSubmitting"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#0BB60B] font-medium cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
              <svg class="size-6 lg:size-8" fill="#0BB60B" viewBox="0 0 56.00 56.00" xmlns="http://www.w3.org/2000/svg"
                stroke="#0BB60B">
                <g transform="translate(9.52,9.52), scale(0.66)">
                  <rect x="0" y="0" width="56.00" height="56.00" rx="0" fill="#ffffff"></rect>
                </g>
                <path
                  d="M 13.7851 49.5742 L 42.2382 49.5742 C 47.1366 49.5742 49.5743 47.1367 49.5743 42.3086 L 49.5743 13.6914 C 49.5743 8.8633 47.1366 6.4258 42.2382 6.4258 L 13.7851 6.4258 C 8.9101 6.4258 6.4257 8.8398 6.4257 13.6914 L 6.4257 42.3086 C 6.4257 47.1602 8.9101 49.5742 13.7851 49.5742 Z M 27.9882 39.6367 C 26.6523 39.6367 25.9492 38.6758 25.9492 37.3164 L 25.9492 30.0274 L 18.2617 30.0274 C 16.8788 30.0274 15.9179 29.3008 15.9179 28.0118 C 15.9179 26.6758 16.8320 25.9258 18.2617 25.9258 L 25.9492 25.9258 L 25.9492 18.1680 C 25.9492 16.8086 26.6523 15.8477 27.9882 15.8477 C 29.2773 15.8477 30.0742 16.7617 30.0742 18.1680 L 30.0742 25.9258 L 37.7851 25.9258 C 39.2148 25.9258 40.1054 26.6758 40.1054 28.0118 C 40.1054 29.3008 39.1679 30.0274 37.7851 30.0274 L 30.0742 30.0274 L 30.0742 37.3164 C 30.0742 38.7227 29.2773 39.6367 27.9882 39.6367 Z">
                </path>
              </svg>
              {{ isSubmitting ? 'Saving...' : 'Save Asset' }}
            </button>

            <button *ngIf="assetForm.get('id')?.value" type="submit" [disabled]="assetForm.invalid || isSubmitting"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#649dcd] font-medium cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
              <svg class="size-5 lg:size-7" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="5" fill="#649dcd" />
                <mask id="mask0_1227_7952" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="24"
                  height="24">
                  <rect x="3" y="3" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1227_7952)">
                  <path
                    d="M11.6 25.5L9.7 22.3L6.1 21.5L6.45 17.8L4 15L6.45 12.2L6.1 8.5L9.7 7.7L11.6 4.5L15 5.95L18.4 4.5L20.3 7.7L23.9 8.5L23.55 12.2L26 15L23.55 17.8L23.9 21.5L20.3 22.3L18.4 25.5L15 24.05L11.6 25.5ZM12.45 22.95L15 21.85L17.6 22.95L19 20.55L21.75 19.9L21.5 17.1L23.35 15L21.5 12.85L21.75 10.05L19 9.45L17.55 7.05L15 8.15L12.4 7.05L11 9.45L8.25 10.05L8.5 12.85L6.65 15L8.5 17.1L8.25 19.95L11 20.55L12.45 22.95ZM13.95 18.55L19.6 12.9L18.2 11.45L13.95 15.7L11.8 13.6L10.4 15L13.95 18.55Z"
                    fill="white" />
                </g>
              </svg>
              {{ isSubmitting ? 'Updating...' : 'Update Asset' }}
            </button>

            <button type="button" (click)="resetForm()"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#BB0000] font-medium cursor-pointer">
              <svg class="size-5 lg:size-7" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.5" width="30" height="30" rx="5" fill="#BB0000" />
                <path
                  d="M7.06189 17C7.02104 16.6724 7 16.3387 7 16C7 11.5817 10.5817 8 15 8C17.5006 8 19.7332 9.14727 21.2002 10.9442M21.2002 10.9442V8M21.2002 10.9442V10.9999L18.2002 11M22.9381 15C22.979 15.3276 23 15.6613 23 16C23 20.4183 19.4183 24 15 24C12.6106 24 10.4659 22.9525 9 21.2916M9 21.2916V21H12M9 21.2916V24"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {{ assetForm.get('id')?.value ? 'Cancel Edit' : 'Clear Form' }}
            </button>
            <!-- <button type="button" (click)="viewAllAssets()" class="flex items-center gap-1 text-sm lg:text-lg text-[#005BBB] font-medium cursor-pointer">
              <svg class="size-6 lg:size-9" viewBox="0 0 24 24" fill="none" stroke="#005BBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="9"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
              View All Assets
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="w-full py-3 px-4">

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">

    <div class="p-4 bg-blue-100 border border-blue-200 rounded-lg text-center">
      <p class="text-sm text-blue-800 font-semibold">Total Assets</p>
      <p class="text-2xl font-bold text-blue-900">{{ totalItems }}</p>
    </div>

    <div class="p-4 bg-yellow-100 border border-yellow-200 rounded-lg text-center">
      <p class="text-sm text-yellow-800 font-semibold">Assigned Assets</p>
      <p class="text-2xl font-bold text-yellow-900">{{ assignedAssetsCount }}</p>
    </div>

    <div class="p-4 bg-green-100 border border-green-200 rounded-lg text-center">
      <p class="text-sm text-green-800 font-semibold">Available Assets</p>
      <p class="text-2xl font-bold text-green-900">{{ availableAssetsCount }}</p>
    </div>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
    <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
      <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
        <tr>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Asset Name</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Asset Value</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Assigned to</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Purchase Date</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action</th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-xs">
        <tr *ngFor="let asset of latestAssets; let i = index" class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]">
          <td class="p-3 text-center">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
          <td class="p-3 text-center">{{ asset.name || "-" }}</td>
          <td class="p-3 text-center">{{ asset.value | currency:'INR' }}</td>
          <td class="p-3 text-center" [ngClass]="asset.kalakar ? 'text-green-600 font-medium' : 'text-gray-400'">
            {{ asset?.kalakar?.name || 'Available' }}
          </td>
          <td class="p-3 text-center">{{ asset.purchase_date | date:'dd-MMM-yyyy' }}</td>
          <td class="p-3 text-center">
            <div class="flex items-center justify-center gap-3">
              <button class="cursor-pointer" (click)="patchFormForEdit(asset)" title="Edit Asset"><svg
                  class="size-5 lg:size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg></button>
              <button aria-label="Delete Asset" class="icon-btn text-[#BB0000] hover:scale-110 hover:text-[#990000]"
                title="Delete Asset" (click)="deleteAsset(asset.id)"><svg class="w-5 h-5 md:w-6 md:h-6" fill="none"
                  viewBox="0 0 24 25">
                  <path d="M10 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg></button>
          <td class="p-3 text-center">
            <button (click)="onReturnAsset(asset.id)" title="Return Asset to Inventory"
              class="px-3 py-1.5 text-xs font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300">
              Return
            </button>
          </td>
  </div>
  </td>
  </tr>
  </tbody>
  </table>
</div>

<div *ngIf="totalPages > 1" class="flex justify-between items-center mt-4">
  <span class="text-sm text-gray-700">
    Page <span class="font-semibold">{{ currentPage }}</span> of <span class="font-semibold">{{ totalPages }}</span>
  </span>

  <div class="inline-flex -space-x-px text-sm">
    <button (click)="onPrevPage()" [disabled]="currentPage === 1"
      class="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
      Previous
    </button>
    <button (click)="onNextPage()" [disabled]="currentPage === totalPages"
      class="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
      Next
    </button>
  </div>
</div>
</div>